import { yup } from '@guiker/shared-framework'

export const createListingSchema = yup.object({})

export type CreateListingSchema = yup.InferType<typeof createListingSchema>
